export default "__VITE_ASSET__BTm7MrUk__"